// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@carbon/react';
import type { BypassSummary } from '../../../types';

/** Audit table of bypassed items carried into the onboarding record. The
 * coverage contract records item, reason, and actor (timestamps live in the
 * session's event log, not the bypass summary). */
export default function BypassedItemsTable({ bypasses }: { bypasses: BypassSummary[] }) {
  if (bypasses.length === 0) return null;
  return (
    <div className="obw-bypassed-audit">
      <h5>Bypassed items carried into the record</h5>
      <Table size="sm" aria-label="Bypassed items">
        <TableHead>
          <TableRow>
            <TableHeader>Item</TableHeader>
            <TableHeader>Reason</TableHeader>
            <TableHeader>Actor</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {bypasses.map(bypass => (
            <TableRow key={bypass.item_id}>
              <TableCell>{bypass.item_id}</TableCell>
              <TableCell>{bypass.reason}</TableCell>
              <TableCell>{bypass.actor}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
